module.exports = __webpack_public_path__ + "img/standardLBSQ.2c34a7fe.png";